import gql from 'graphql-tag';

export default gql`
  mutation(
    $suggestionsListId: ID!
    $entryId: ID!
    $code: SuggestionStatusCode!
    $licenseId: ID
    $count: Int
  ) {
    updateSuggestionState(
      suggestionsListId: $suggestionsListId
      entryId: $entryId
      code: $code
      licenseId: $licenseId
      count: $count
    )
  }
`;
